import clsx from 'clsx'

import { Skeleton } from '@/shared/ui/Skeleton'

import styles from './ProductReviewListSkeleton.module.scss'

const REVIEW_SKELETON_COUNT = 3

export const ProductReviewListSkeleton = ({
	count = REVIEW_SKELETON_COUNT,
	className,
	showMediaTabs = false
}: {
	count?: number
	className?: string
	showMediaTabs?: boolean
}) => (
	<div className={clsx(styles.reviewList, className)} aria-hidden="true">
		{Array.from({ length: count }).map((_, index) => (
			<div className={styles.reviewSkeleton} key={index}>
				<div className={styles.reviewSkeletonHeader}>
					<Skeleton width={120} height={18} borderRadius={8} />
					<Skeleton width={92} height={16} borderRadius={8} />
				</div>
				<Skeleton height={16} borderRadius={8} />
				<Skeleton width="76%" height={16} borderRadius={8} />
				{showMediaTabs && (
					<div className={styles.reviewSkeletonMediaTabs}>
						{Array.from({ length: 3 }).map((_, mediaIndex) => (
							<Skeleton
								className={styles.reviewSkeletonMediaTab}
								width={60}
								height={60}
								borderRadius={6}
								key={mediaIndex}
							/>
						))}
					</div>
				)}
				<div className={styles.reviewSkeletonFooter}>
					<Skeleton width={82} height={14} borderRadius={7} />
					<Skeleton width={104} height={40} borderRadius={20} />
				</div>
			</div>
		))}
	</div>
)
